export default "__VITE_ASSET__3v_Z71Bs__"